'use strict';

function reverseString(str) {
  return str.split('').reverse().join('');
}

module.exports = reverseString;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/string/internal/reverseString.js
// module id = 572
// module chunks = 0